
import { useMemo } from 'react';
import useScrollProgress from './useScrollProgress';

const useDarkOverlay = (sectionId: string) => {
  const { progress } = useScrollProgress(sectionId);

  const darkOverlayOpacity = useMemo(() => {
    // Start early at 0.1 (when Logistik section appears) and be fully dark by 0.5 (before Redo att sälja)
    return Math.max(0, Math.min((progress - 0.1) * 2.5, 1));
  }, [progress]);

  return { darkOverlayOpacity, progress };
};

export default useDarkOverlay;
